import React from 'react';

const ObjectionChart = ({ meetings }) => {
  // Calcular objeciones totales de las reuniones pasadas
  const totalObjections = meetings.reduce((acc, meeting) => {
    if (meeting.objections) {
      acc.price += meeting.objections.price || 0;
      acc.location += meeting.objections.location || 0;
      acc.noResponse += meeting.objections.noResponse || 0;
      acc.schedule += meeting.objections.schedule || 0;
    }
    return acc;
  }, { price: 0, location: 0, noResponse: 0, schedule: 0 });

  const chartData = [
    { label: 'Precio', value: totalObjections.price, color: 'bg-red-500' },
    { label: 'Ubicación', value: totalObjections.location, color: 'bg-yellow-500' },
    { label: 'No contestan', value: totalObjections.noResponse, color: 'bg-orange-500' },
    { label: 'Horarios', value: totalObjections.schedule, color: 'bg-blue-500' }
  ];

  const totalCount = chartData.reduce((sum, item) => sum + item.value, 0);

  if (totalCount === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mt-6">
        <h3 className="text-lg font-semibold text-[#0061A8] mb-4">Objeciones Registradas</h3>
        <p className="text-[#63666A] text-sm">No hay objeciones registradas para este cliente aún.</p>
      </div>
    );
  }

  const maxVal = Math.max(...chartData.map(d => d.value));
  const scaleFactor = 100 / (maxVal === 0 ? 1 : maxVal);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-6">
      <h3 className="text-lg font-semibold text-[#0061A8] mb-4">Objeciones Registradas (Personas)</h3>
      <div className="space-y-4">
        {chartData.map((item, index) => (
          <div key={index}>
            <div className="flex justify-between text-sm text-[#63666A]">
              <span>{item.label}: {item.value}</span>
              <span>{item.value}</span>
            </div>
            <div className="w-full bg-[#D1D3D4] rounded-full h-2.5">
              <div className={`${item.color} h-2.5 rounded-full`} style={{ width: `${item.value * scaleFactor}%` }}></div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-sm text-[#63666A] mt-4">Total de objeciones registradas: {totalCount} personas.</p>
    </div>
  );
};

export default ObjectionChart;